class PolicyContactDetailsCtrl {
    constructor($stateParams, ContactService, ViewModelService, $state) {
        this.getPolicyContactDetails = getPolicyContactDetails;

        function getPolicyContactDetails() {
            return ContactService.getPolicyContactDetails($stateParams.contactNumber, $stateParams.policyNumber)
                .then(contact => {
                    this.contactModel = ViewModelService.create(
                        contact,
                        'pc',
                        'edge.capabilities.gateway.contact.dto.PolicyContactDetailsDTO'
                    );
                }).catch(err => {
                    console.error(err);
                    $state.go('gatewayLanding');
                });
        }


        this.policyContactDetailsPromise = this.getPolicyContactDetails();
    }
}

PolicyContactDetailsCtrl.$inject = ['$stateParams', 'ContactService', 'ViewModelService', '$state'];
export default PolicyContactDetailsCtrl;
